import { Component, OnInit } from '@angular/core';
import { Itemuom } from './item-uom';
import { ItemuomService } from '../item-uom/item-uom.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-item-uom',
  templateUrl: './item-uom.component.html',
  styleUrls: ['./item-uom.component.css']
})
export class ItemUomComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  itemuom = new Itemuom();  //Po is defined from abobe import po
  itemuoms:any= [];
  submitted = false;
	message: string;	
	totalrecord:number;
 itemuomFilter: any = { uom: '' };
  constructor(
  private itemuomService: ItemuomService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getItemuoms();
  }

  getItemuoms() {
    this.spinnerService.show();
    return this.itemuomService.getItemuoms()
               .subscribe(
                itemuoms => {
                  console.log(itemuoms);
                  this.itemuoms = itemuoms
                  this.totalrecord = this.itemuoms.length;
                  this.spinnerService.hide();
                 }
                );
 }
 public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

}
